import React from "react";
import Footer from "../components/common/Footer";
function AboutUs() {
  return (
    <div>
      <div className="min-h-[calc(100vh-5.8rem)] w-11/12 mx-auto  pt-8">
        About 
      </div>
      <Footer />
    </div>
  );
}

export default AboutUs;
